import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'
import type { RecoveryLocation, RecoveryObject } from '../../api'
import { RecoveryObjectCard, type ChangeState } from './RecoveryObjectCard'

/** One column per location listing its recovery objects, with a change indicator. */
export function LocationColumn({
    location,
    objects,
    changeFor,
}: {
    location: RecoveryLocation
    objects: RecoveryObject[]
    changeFor: (obj: RecoveryObject) => ChangeState
}) {
    const { t } = useTranslation()
    const anyChanged = objects.some((o) => changeFor(o) != null)

    return (
        <div className="flex w-72 shrink-0 flex-col gap-2">
            <div className="flex items-center gap-2 px-1">
                <span
                    className={cn(
                        'h-2 w-2 shrink-0 rounded-full',
                        anyChanged ? 'animate-pulse bg-warning' : 'bg-muted-foreground/30',
                    )}
                    aria-hidden
                />
                <h3 className="truncate text-sm font-semibold text-foreground" title={location.name}>
                    {location.name}
                </h3>
                <span className="text-xs text-muted-foreground">({objects.length})</span>
            </div>

            {objects.length === 0 ? (
                <div className="rounded-lg border border-dashed p-4 text-center text-xs text-muted-foreground">
                    {t('recoverRequests.locationTracking.noObjects', 'No objects at this location')}
                </div>
            ) : (
                objects.map((o) => <RecoveryObjectCard key={o.id} obj={o} changeState={changeFor(o)} />)
            )}
        </div>
    )
}
